import React from 'react';
import PropTypes from 'prop-types';
import { ModalBody } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import PrimaryButton from '../buttons/PrimaryButton';
import useStyles from './styles';

const ContactUsModal = ({ onHide }) => {
  const { t } = useTranslation(['translation', 'COMMON']);
  const classes = useStyles();
  return (
    <ModalBody className={classes.contactUsModalContainer}>
      <div>{t('COMMON.CONTACT_US_TEXT')}</div>
      <div className={classes.contactUsModalBtn}>
          <PrimaryButton onClick={onHide}>{t(`COMMON.OK`)}</PrimaryButton>
      </div>
    </ModalBody>
  );
};


ContactUsModal.propTypes = {
  onHide: PropTypes.func.isRequired,
};

export default ContactUsModal;